import { lazy } from 'react'

const Superuser = lazy(() => import('@/routes/superuser/Superuser.tsx'))
const ProtectedRoute = lazy(() => import('@/components/common/wrappers/ProtectedRoute.tsx'))

export const SUPERUSER_ROUTES = {
  path: 'superuser',
  element: (
    <ProtectedRoute specialUserOnly={true}>
      <Superuser />
    </ProtectedRoute>
  ),
}
